<template>
  <svg
      xmlns:dc="http://purl.org/dc/elements/1.1/"
      xmlns:cc="http://creativecommons.org/ns#"
      xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
      xmlns:svg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg"
      id="svg8"
      version="1.1"
      viewBox="0 0 164.04166 32.505951"
      height="32.505951mm"
      width="164.04166mm"
      fill="currentColor"
  >
    <defs
        id="defs2" />
    <metadata
        id="metadata5">
      <rdf:RDF>
        <cc:Work
            rdf:about="">
          <dc:format>image/svg+xml</dc:format>
          <dc:type
              rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
          <dc:title></dc:title>
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <g
        transform="translate(15.875,-30.148809)"
        id="layer1">
      <path
          id="rect815"
          d="M -15.875,30.148809 H 127.75595 L 148.16666,62.65476 H -15.875 Z"
          style="opacity:1;vector-effect:none;fill:inherit;fill-opacity:1;stroke:none;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;marker:none" />
    </g>
  </svg>
</template>

<script>
export default {
  name: "BgSlanted"
}
</script>

<style scoped>

</style>